// Open the FAQ accordion panel matching the URL hash so existing #anchor links still deep link
function openFaqFromHash() {
  const target = window.location.hash && document.getElementById(decodeURIComponent(window.location.hash.slice(1))),
    panel = target && target.closest('.hc-faq .accordion-collapse');
  if (!panel) {
    return;
  }
  const scrollToTarget = function () {
    (target === panel ? panel.closest('.accordion-item') : target).scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  if (panel.classList.contains('show')) {
    scrollToTarget();
    return;
  }
  panel.addEventListener('shown.bs.collapse', scrollToTarget, {
    once: true
  });
  bootstrap.Collapse.getOrCreateInstance(panel, {
    toggle: false
  }).show();
}
$(openFaqFromHash);
$(window).on('hashchange', openFaqFromHash);
$('#contactUsForm').on('submit', function (e) {
  e.preventDefault();
  sendContactForm();
});
function sendContactForm() {
  const $form = $('#contactUsForm'),
    spinner = new Spinner();
  $form.parent().find('.alert').remove();
  $.ajax({
    type: 'POST',
    async: true,
    url: '/help/contact-us-json',
    contentType: 'application/json; charset=utf-8',
    data: JSON.stringify({
      emailTo: $('#contactUsForm #emailTo').val(),
      email: $('#contactUsForm #email').val(),
      message: $('#contactUsForm #message').val()
    }),
    dataType: 'json',
    context: this,
    beforeSend: function () {
      DK.displayBlocker($form);
      spinner.spin($form.get()[0]);
    },
    complete: function () {
      DK.hideBlocker($form);
      spinner.stop();
    }
  }).done(function (data) {
    displayContactFeedback(data);
  }).fail(function (xhr, textStatus, errorThrown) {
    $(`<div class="alert alert-danger">Your email message was not sent.
			Please try again later.</div>`).insertBefore('#contactUsForm');
  });
}
function displayContactFeedback(data) {
  //remove previous errors
  const $form = $('#contactUsForm');
  $form.find('.is-invalid').removeClass('is-invalid');
  if (data.errors) {
    // Display the form validation errors
    for (key in data.errors) {
      const $input = $form.find('#' + key);
      $input.addClass('is-invalid');
      $input.parent().append(`<small class="invalid-feedback">${data.errors[key]}</span>`);
    }
  } else {
    // Hide the form and display a success message when the form submission succeeds
    $('<div class="alert alert-success">Your email message has been sent.</div>').insertBefore($form);
    $form.find('input[type="submit"]').attr('disabled', 'disabled');
    $form.slideUp();
  }
}